import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Horse_show_entry } from '../models/horse_show_entry';
import { Horse } from '../models/horse';
import { Person } from '../models/person';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class HorseShowEntryService {

  constructor(private http: HttpClient) { }

  get(id: string, include_statement: boolean, include_competition_entries: boolean, lean: boolean): Promise<Horse_show_entry> {
	    return this.getWithRestFragment('id/' + id + '/competitions/' + include_competition_entries + '/statement/' + include_statement + '/lean/' + lean);
	}

  getForCheckout(id: string, include_statement: boolean, include_competition_entries: boolean, lean: boolean): Promise<Horse_show_entry> {
      return this.getWithRestFragment('id/' + id + '/competitions/' + include_competition_entries + '/json_statement/' + include_statement + '/lean/' + lean);
  }

	private getWithRestFragment(rest_fragment: string): Promise<Horse_show_entry> {
	    return new Promise((resolve, reject) => {
	      return this.http.get(AppSettings.API_ENDPOINT + 'horse_show_entries/' + rest_fragment).subscribe((response:any) => {
	        if(response.type == 'horse_show_entry' && response.data){
	          resolve(response.data);
	        } else {
	          reject(response);
	        }

	      },
	        error_response => {
	              if(error_response instanceof HttpErrorResponse){
	                reject(error_response.error);
	              }
	              reject(error_response);
	        });
	    });
  }

  updateAdditionalInformation(hs_entry: Horse_show_entry): Promise<boolean> {

    let add_info = {
      arrival_date: hs_entry.arrival_date,
      stable_with: hs_entry.stable_with,
      comments: hs_entry.comments,
      emergency_contact_name: hs_entry.emergency_contact_name,
      emergency_contact_number: hs_entry.emergency_contact_number,
      additional_fields: hs_entry.additional_fields
    };


    let put_data = {
          data: {type: 'information_update_request',
          attributes: { entry_id: hs_entry.id, info: add_info }
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.put(AppSettings.API_ENDPOINT + 'horse_show_entries',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='information_update_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });
  }

  updatePayeeOnEntry(entry_id: string, payee_id: string): Promise<boolean> {
   let put_data = {
          data: {type: 'payee_change_request',
          attributes: { entry_id: entry_id, payee_id: payee_id }
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.put(AppSettings.API_ENDPOINT + 'horse_show_entries',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='payee_change_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });

  }

  addRiderToEntry(entry_id: string, person_id: string): Promise<boolean> {

      let put_data = {
          data: {type: 'rider_add_request',
          attributes: { entry_id: entry_id, person_id: person_id}
          }
        };

      return new Promise((resolve, reject) => {

      return this.http.post(AppSettings.API_ENDPOINT + 'horse_show_entries',
          put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
               if(response.data && response.type=='rider_add_response') {
                 resolve(response.data);
                 }  else {
                   reject(response);
                 }

          }, error => {
            if(error instanceof HttpErrorResponse){
                reject(error.error);
              } else {
                reject(error);
              }
          });
      });
  }

}
